import qs from 'qs'

export const useTableSearch = (search) => {

    // Filter functionality
    const queryParams = qs.parse(search, { ignoreQueryPrefix: true })

    return {
        searchBy: queryParams['searchBy'],
        searchValue: queryParams['searchValue']
    }
}